import React, { Component } from 'react'
import Scroll from 'react-scroll'
import config from '../config.json'
import Stripe from './Stripe'
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails.jsx'
import hasToggleMovieDatesOnMobile from '../hoc/hasToggleMovieDatesOnMobile.jsx'
import { trackMovieInformationOpen, trackMoviePerformanceOpen } from '../tracking'
import getMovieLink from '../functions/getMovieLink'
import SlideActiveItem from '../SliderGeneral/SlideActiveItem'
import hasGridInformation from '../hoc/hasGridInformation.jsx'
import GridMovieInformation from '../Overview/FilterResultsGrid/GridMovieInformation.jsx'
import GridItems from '../Overview/FilterResultsGrid/GridItems.jsx'
import Translation from '../General/Translation.jsx'
const breakpoints = config.breakpoints


let Element = Scroll.Element
class SliderStripe extends Component {
    constructor(props) {
        super(props)
    }

    componentDidUpdate(prevProps) {
        const {currentActiveSelection, selectionId, activeItem, onCloseInformation} = this.props
        if (currentActiveSelection !== prevProps.currentActiveSelection) {
            if(currentActiveSelection && currentActiveSelection !== selectionId && activeItem) {
                onCloseInformation()
            }
        }
    }

    getEventOrigins() {
        const { title } = this.props

        return {
            stripe:                 'Startseite, Filmstreifen "' + title + '", Posterelement',
            information:            'Startseite, Filmstreifen "' + title + '", Film Imformation',
            informationSlidebar:    'Startseite, Filmstreifen "' + title + '", Film Imformation/rechte Slidebar',
            details:                'Startseite, Filmstreifen "' + title + '", Film Details',
            detailsSlidebar:        'Startseite, Filmstreifen "' + title + '", Film Details/rechte Slidebar',
            performance:            'Startseite, Filmstreifen "' + title + '", Film Vorführung',
            performanceSlidebar:    'Startseite, Filmstreifen "' + title + '", Film Vorführung/rechte Slidebar'
        }
    }

    render() {
        const { 
            title, 
            items, 
            moviesData, 
            moviesRoutesData,
            translation,
            adsData, 
            scrollToPosition, 
            settings, 
            features,
            isMobile, 
            displaySidebarRight, 
            displaySidebarRightSecond, 
            activeItem, 
            activeDetailsItem,
            activePerformance, 
            performancePageOpen,
            onCloseDetails,
            onOpenDetails,
            onOpenPerformancePage,
            onClosePerformancePage,
            onCloseInformation,
            onOpenInformation,
            selectionStyle,
            currentDateActive, 
            stripeAppearance,
            routesData,
            toggleMovieDatesOnMobileView,
            filterType,
            filterValue,
            theme,
            row,
            movieInformationOrder
        } = this.props

        const eventOrigins = this.getEventOrigins()
        const itemLink = getMovieLink(activeItem, moviesRoutesData, translation)
        const detailsOpen = activeDetailsItem === activeItem
        const movieItems = _.pluck(items, 'id');

        if(items[0]) {
            return (
                <div className={scrollToPosition + ' ' + stripeAppearance}>
                    <div className='titles-wrapper'>
                        {title && <h2 className="slider-title title-large">{title}</h2>}
                        {routesData && routesData.program_overview[translation.currentLang] && selectionStyle === "OverviewButton" && <a className="full-program-button" href={routesData.program_overview[translation.currentLang].uri}>
                            <p><Translation className="full-program-button" id="fullProgram" trans={translation}>Komplettes Programm</Translation></p>
                            <svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.99 11.49">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <polygon points="12.33 0 10.78 1.26 13.61 4.75 0 4.75 0 6.75 13.6 6.75 10.78 10.24 12.33 11.49 16.99 5.73 12.33 0"/>
                                </g>
                            </svg>
                        </a>}
                    </div>

                    {stripeAppearance === 'no_slide' ? (
                            <div className={"overview-grid slider-wrapper " + stripeAppearance}>
                            <GridItems
                                items={movieItems}
                                activeItem={activeItem}
                                theme={theme}
                                isSlider={true}
                                additionalScrollName={scrollToPosition}
                                itemsData={moviesData}
                                showPerformances={true}
                                translation={translation}
                                itemOnClick={trackMovieInformationOpen(onOpenInformation, eventOrigins.stripe)}
                                onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.stripe)}
                                movieInformationOrder={movieInformationOrder}
                                isMobile={isMobile}
                                hasGridHoverTrailer={false}
                                interscrollerId={null}
                                interscrollerType={null}
                                interscrollerWeischerAds={null}
                                interscrollerAdvertisements={null}
                                isConnectedFast={null}
                            />
                            <GridMovieInformation
                                theme={theme}
                                additionalScrollName={scrollToPosition}
                                queryStringValues={null}
                                isMobile={isMobile}
                                activeItem={activeItem}
                                itemsData={moviesData}
                                activeDetailsItem={activeDetailsItem}
                                displaySidebarRight={displaySidebarRight}
                                displaySidebarRightSecond={displaySidebarRightSecond}
                                closeItemInformation={onCloseInformation}
                                openItemDetails={onOpenDetails}
                                closeItemDetails={onCloseDetails}
                                movieInformationOrder={movieInformationOrder}
                                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                                currentDateActive = {currentDateActive}
                                row={row}
                                activePerformance={activePerformance}
                                translation={translation}
                                itemLink={getMovieLink(activeItem, moviesRoutesData, translation)}
                                eventOrigins={eventOrigins}
                                performancePageOpen={performancePageOpen}
                                onOpenPerformancePage={onOpenPerformancePage}
                                onClosePerformancePage={onClosePerformancePage}
                                hasMerchandising={features.has_merchandising}
                            />
                        </div>
                    ) : (
                        <>
                            <div className={"slider-wrapper"}>
                                <Element name={scrollToPosition}></Element>
                                <Stripe 
                                    items={items}
                                    theme={theme}
                                    moviesData={moviesData}
                                    stripeAppearance={stripeAppearance} //is needed for overwrite
                                    movieInformationOrder={movieInformationOrder}
                                    adsData={adsData}
                                    translation={translation}
                                    activeItem={activeItem}
                                    settings={settings}
                                    scrollToPosition={scrollToPosition}
                                    filterValue={filterValue}
                                    filterType={filterType}
                                    isMobile={isMobile}
                                    onClickSlideItem={trackMovieInformationOpen(onOpenInformation, eventOrigins.stripe)}
                                    onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.stripe)}
                                />
                            </div>
                            <SlideActiveItem
                                itemLink={itemLink}
                                activeItem={activeItem}
                                filterValue={filterValue}
                                filterType={filterType}
                                theme={theme}
                                activePerformance={activePerformance}
                                currentDateActive={currentDateActive}
                                isMobile={isMobile}
                                scrollToPosition={scrollToPosition}
                                eventOrigins={eventOrigins}
                                moviesData={moviesData}
                                translation={translation}
                                displaySidebarRight={displaySidebarRight}
                                displaySidebarRightSecond={displaySidebarRightSecond}
                                performancePageOpen={performancePageOpen}
                                detailsOpen={detailsOpen}
                                hasMerchandising={features.has_merchandising}
                                onCloseInformation={onCloseInformation}
                                onOpenDetails={onOpenDetails}
                                onCloseDetails={onCloseDetails}
                                onOpenPerformancePage={onOpenPerformancePage}
                                onClosePerformancePage={onClosePerformancePage}
                                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                            />
                        </>
                    )}
                </div>
            )
        } else {
            return ''
        }
    }
}

export default hasSlidebarRightAndSecond({breakpoint:  breakpoints.slidebarRight})(hasToggleMovieDatesOnMobile(hasOpenInformationAndDetails(hasGridInformation(SliderStripe))))
